import React from 'react';
import { AppStep } from '../src/types';

interface FooterProps {
  onNavigate: (step: AppStep) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://firebasestorage.googleapis.com/v0/b/history-essay-bot.firebasestorage.app/o/transparent%20logo%20market%20mate%20(2).webp?alt=media&token=577c40fb-e028-4260-b65d-3545512569dd" 
                alt="AI Marker Mate Logo" 
                className="h-8 w-auto mr-3"
              />
              <h3 className="text-lg font-semibold text-foreground">AI Marker Mate</h3>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Empowering Australian educators with intelligent assessment technology. 
              Designed to enhance teaching effectiveness and provide quality feedback to students faster.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => onNavigate(AppStep.ABOUT)}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate(AppStep.HELP_CONTACT)}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  Help & Support
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate(AppStep.CONTACT_US)}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => onNavigate(AppStep.PRIVACY_POLICY)}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate(AppStep.TERMS_OF_SERVICE)}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate(AppStep.REFUND_POLICY)}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  Refund Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-border pt-6 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-muted-foreground text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} AI Marker Mate. All rights reserved. Proudly Australian.
            </p>
            <div className="flex items-center space-x-4">
              <span className="text-xs text-muted-foreground/70">Made with ❤️ for educators</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
